<template>
  <div id="app" v-if="isload">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view :key="url_load+$route.params.toString()+random_string"/>
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import {FadeTransition} from "vue2-transitions";
import {eventBus} from "./main.js";
import axios from "axios";
import Vue from "vue";
import Api from "./models/Api";
import "@/assets/css/custom.css";



export default {
  components: {
    FadeTransition
  },
  data: function () {
    return {
      'isload': false,
      "url_load":"",
      "random_string":"",
    }
  },
  watch: {
    // $route() {
    //   this.$nextTick(this.routeLoaded);
    // }
    $route(to, from) {
      // react to route changes...
      console.log('to route');
      console.log(to);
      console.log('from route');
      console.log(from);
      if(from.path!="/"){
        if(!(window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData)){
          location.reload();
        }

      }

      if (to !== from) {
      //  console.log("to is");
       // console.log(to);
       // console.log('from is');
       // console.log(from);
        //location.reload();
      }
    }
  },
  methods:{
    routeLoaded() {

    }
  },
  mounted() {
    var url=this.$route.fullPath;
    console.log(this.$route.params.toString());

    // if(url && url.includes("#tgWebAppData=")){
    //
    //
    //   var urls=url.split("#tgWebAppData=");
    //   if(urls[0]){
    //
    //     this.url_load=urls[0];
    //   }
    // }else {
    //   this.url_load=url;
    // }
    this.url_load=url;
     var current_app=this;
    eventBus.$on("refresh_fast_page",data=>{



      current_app.isload=false;
      current_app.random_string=Math.ceil(Math.random()*10);

      current_app.isload=true;


    })

   // alert('11');
   //  this.$router.onError(function(e){
   //    console.log('first err');
   //  })
   //  if(this.$route.hash && this.$route.hash.includes("#tgWebAppData=")){
   //    this.$route.hash="";
   //  }
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        // if(this.$route.hash && this.$route.hash.includes("tgWebAppData=")){
        //
        //   var fullPath=this.$route.fullPath;
        //   var arrs=fullPath.split("#tgWebAppData");
        //   var normal_url=window.location.pathname;
        //
        //   var arr_router={};
        //   arr_router.path=normal_url;
        //   var query={};
        //   if(this.$route.query.rand_code){
        //     query.rand_code=this.$route.query.rand_code;
        //   }
        //
        //   if(this.$route.query.redirect_inner){
        //     query.redirect_inner=this.$route.query.redirect_inner;
        //   }
        //   arr_router.query=query;
        //
        //   this.$router.push(arr_router);
        //
        //   //document.location=arrs[0];
        //
        // }else {
        //   this.isload=true;
        // }
        this.isload=true;

        eventBus.$on('reload', (user) => {

          Api.loadUserInfo(user.api_token);
        });
      }
    }

   // alert(this.$route.hash);




    eventBus.$on('update_user_info', (isauth, isadmin) => { // here you need to use the arrow function
      app.isauth = isauth;
      app.isadmin = isadmin;

    })
  },
};
</script>
